/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["kt-base{opacity:0;height:100%}kt-base .kt-grid--root{height:100%}.kt-page--loaded kt-base{opacity:1;transition:opacity 1s ease-in-out}.container.wrapper{min-height:calc(100vh - 87px)}@media (max-width:600px){.container.wrapper{min-height:calc(100vh - 400px)}}"];
export { styles as styles };
